export default __webpack_public_path__ + "static/media/Zombie.350a4a00.mp4";